import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from "./Icon.svelte";

var root = $.from_html(`<img alt="" decoding="async"/>`);
var root_1 = $.from_html(`<span class="media-loading">Loading</span>`);
var root_2 = $.from_html(`<span class="video-meta"><span> </span></span> <span class="video-download-mark"><!> Original</span>`, 1);
var root_3 = $.from_html(`<img alt=""/>`);
var root_4 = $.from_html(`<span aria-hidden="true" class="media-contributor"><!></span>`);
var root_5 = $.from_html(`<span aria-hidden="true" class="photo-selection-mark"><!></span>`);
var root_6 = $.from_html(`<button class="media-action" data-action="download-photo" title="Download original" type="button"><!></button>`);
var root_7 = $.from_html(`<button class="media-action media-action-delete" data-action="delete-photo" title="Delete photo" type="button"><!></button>`);
var root_8 = $.from_html(`<div class="media-actions"><!> <!></div>`);
var root_9 = $.from_html(`<article role="listitem"><button type="button"><!> <!> <!> <!></button> <!></article>`);
var root_10 = $.from_html(`<div class="gallery-grid" role="list"><div class="gallery-empty" role="status"><h2>Photos are on their way</h2> <p>Keep this page open while this share becomes available.</p></div></div>`);
var root_11 = $.from_html(`<section class="gallery-date-group"><h2 class="gallery-date-heading"> </h2> <div class="gallery-grid" role="list"><!></div></section>`);
var root_12 = $.from_html(`<div class="gallery-date-groups"></div>`);
var root_13 = $.from_html(`<div class="gallery-grid" role="list"><!></div>`);

export default function GalleryGrid($$anchor, $$props) {
	$.push($$props, true);

	const mediaTiles = ($$anchor, items = $.noop, startIndex = $.noop) => {
		var fragment = $.comment();
		var node = $.first_child(fragment);

		$.each(node, 19, items, (item) => item.id, ($$anchor, item, index) => {
			const selectable = $.derived(() => $$props.access === "download" && photoSelectionActive() && $.get(item).kind === "image");
			const selected = $.derived(() => $.get(selectable) && $.get(selectedIds).has($.get(item).id));
			const contributor = $.derived(() => contributorName($.get(item)));
			const contributorAvatar = $.derived(() => contributorAvatarUrl($.get(item)));
			var article = root_9();
			let classes;
			var button = $.child(article);
			var node_1 = $.child(button);

			{
				var consequent = ($$anchor) => {
					var img = root();

					$.template_effect(() => {
						$.set_attribute(img, 'loading', startIndex() + $.get(index) < 6 ? "eager" : "lazy");
						$.set_attribute(img, 'src', $.get(item).source);
					});

					$.append($$anchor, img);
				};

				var alternate = ($$anchor) => {
					var span = root_1();

					$.append($$anchor, span);
				};

				$.if(node_1, ($$render) => {
					if ($.get(item).source) $$render(consequent); else $$render(alternate, -1);
				});
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent_1 = ($$anchor) => {
					var fragment_1 = root_2();
					var span_1 = $.first_child(fragment_1);
					var span_2 = $.child(span_1);
					var text = $.child(span_2, true);

					$.reset(span_2);
					$.reset(span_1);

					var span_3 = $.sibling(span_1, 2);
					var node_3 = $.child(span_3);

					Icon(node_3, { name: 'download' });
					$.next();
					$.reset(span_3);
					$.template_effect(() => $.set_text(text, $.get(item).durationLabel ?? ""));
					$.append($$anchor, fragment_1);
				};

				$.if(node_2, ($$render) => {
					if ($.get(item).kind === "video") $$render(consequent_1);
				});
			}

			var node_4 = $.sibling(node_2, 2);

			{
				var consequent_3 = ($$anchor) => {
					var span_4 = root_4();
					var node_5 = $.child(span_4);

					{
						var consequent_2 = ($$anchor) => {
							var img_1 = root_3();

							$.template_effect(() => $.set_attribute(img_1, 'src', $.get(contributorAvatar)));
							$.append($$anchor, img_1);
						};

						var alternate_1 = ($$anchor) => {
							var text_1 = $.text();

							$.template_effect(($0) => $.set_text(text_1, $0), [() => contributorInitials($.get(contributor))]);
							$.append($$anchor, text_1);
						};

						$.if(node_5, ($$render) => {
							if ($.get(contributorAvatar)) $$render(consequent_2); else $$render(alternate_1, -1);
						});
					}

					$.reset(span_4);
					$.append($$anchor, span_4);
				};

				$.if(node_4, ($$render) => {
					if ($.get(contributor)) $$render(consequent_3);
				});
			}

			var node_6 = $.sibling(node_4, 2);

			{
				var consequent_4 = ($$anchor) => {
					var span_5 = root_5();
					var node_7 = $.child(span_5);

					Icon(node_7, { name: 'select' });
					$.reset(span_5);
					$.append($$anchor, span_5);
				};

				$.if(node_6, ($$render) => {
					if ($.get(selectable)) $$render(consequent_4);
				});
			}

			$.reset(button);

			var node_8 = $.sibling(button, 2);

			{
				var consequent_7 = ($$anchor) => {
					var div = root_8();
					var node_9 = $.child(div);

					{
						var consequent_5 = ($$anchor) => {
							var button_1 = root_6();
							var node_10 = $.child(button_1);

							Icon(node_10, { name: 'download' });
							$.reset(button_1);

							$.template_effect(() => {
								$.set_attribute(button_1, 'aria-label', `Download original ${$.get(item).label}`);
								$.set_attribute(button_1, 'data-media-id', $.get(item).id);
							});

							$.append($$anchor, button_1);
						};

						$.if(node_9, ($$render) => {
							if ($$props.access === "download" && $.get(item).canDownloadOriginal) $$render(consequent_5);
						});
					}

					var node_11 = $.sibling(node_9, 2);

					{
						var consequent_6 = ($$anchor) => {
							var button_2 = root_7();
							var node_12 = $.child(button_2);

							Icon(node_12, { name: 'trash' });
							$.reset(button_2);

							$.template_effect(() => {
								$.set_attribute(button_2, 'aria-busy', $.get(item).deleting ? "true" : undefined);
								$.set_attribute(button_2, 'aria-label', `Delete ${$.get(item).label}`);
								$.set_attribute(button_2, 'data-media-id', $.get(item).id);
								button_2.disabled = $.get(item).deleting;
							});

							$.append($$anchor, button_2);
						};

						$.if(node_11, ($$render) => {
							if ($.get(item).canDelete) $$render(consequent_6);
						});
					}

					$.reset(div);
					$.append($$anchor, div);
				};

				$.if(node_8, ($$render) => {
					if (!$.get(selectable) && $.get(item).kind === "image" && ($$props.access === "download" && $.get(item).canDownloadOriginal || $.get(item).canDelete)) $$render(consequent_7);
				});
			}

			$.reset(article);

			$.template_effect(
				($0, $1, $2, $3) => {
					classes = $.set_class(article, 1, 'media-item', null, classes, $0);
					$.set_style(article, $1);
					$.set_attribute(button, 'aria-label', $2);
					$.set_attribute(button, 'aria-pressed', $3);
					$.set_class(button, 1, `media-tile media-${$.get(item).kind}${$.get(selected) ? " is-selected" : ""}`);

					$.set_attribute(button, 'data-action', $.get(selectable)
						? "toggle-photo-selection"
						: $.get(item).kind === "video" ? "open-video" : "open-photo");

					$.set_attribute(button, 'data-media-id', $.get(item).id);
				},
				[
					() => ({ 'media-item-wide': isWideMedia($.get(item)) }),
					() => mediaStyle($.get(item)),
					() => mediaLabel($.get(item), startIndex() + $.get(index), $.get(selected)),
					() => $.get(selectable) ? String($.get(selected)) : undefined
				]
			);

			$.append($$anchor, article);
		});

		$.append($$anchor, fragment);
	};

	let groupByDate = $.prop($$props, 'groupByDate', 3, false),
		photoSelectionActive = $.prop($$props, 'photoSelectionActive', 3, false),
		selectedPhotoIds = $.prop($$props, 'selectedPhotoIds', 19, () => []);

	let selectedIds = $.derived(() => new Set(selectedPhotoIds()));
	let dateGroups = $.derived(() => groupByDate() ? groupMediaByDate($$props.media) : []);

	function mediaStyle(item) {
		const ratio = Number.isFinite(item.aspectRatio) && item.aspectRatio > 0 ? item.aspectRatio : 1;

		return `--media-ratio:${ratio};--media-basis-desktop:${Math.round(ratio * 260)}px;--media-basis-desktop-wide:${Math.round(ratio * 310)}px;--media-basis-desktop-xl:${Math.round(ratio * 340)}px;--media-basis-mobile:${Math.round(ratio * 172)}px`;
	}

	function isWideMedia(item) {
		return Number.isFinite(item.aspectRatio) && item.aspectRatio >= 1.3;
	}

	function mediaLabel(item, index, selected) {
		const originalSize = item.kind === "image" && item.originalSizeLabel ? `, original ${item.originalSizeLabel}` : "";
		const contributor = contributorName(item);
		const contributorDetail = contributor ? `, added by ${contributor}` : "";

		if (photoSelectionActive() && $$props.access === "download" && item.kind === "image") {
			return `${selected ? "Deselect" : "Select"} photo ${index + 1} of ${$$props.media.length}: ${item.label}${contributorDetail}${originalSize}`;
		}

		return `${item.kind === "video" ? "Video" : "Photo"} ${index + 1} of ${$$props.media.length}: ${item.label}${contributorDetail}${originalSize}`;
	}

	function contributorName(item) {
		return item.uploadedBy?.displayName ?? $$props.ownerName;
	}

	function contributorAvatarUrl(item) {
		return item.uploadedBy?.avatarUrl ?? $$props.ownerAvatarUrl;
	}

	function contributorInitials(displayName) {
		return displayName.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]?.toUpperCase() ?? "").join("");
	}

	function groupMediaByDate(media) {
		const groups = [];

		for (const [index, item] of media.entries()) {
			const timestamp = item.createdAt ? Date.parse(item.createdAt) : Number.NaN;
			const date = Number.isFinite(timestamp) ? new Date(timestamp) : undefined;

			const key = date
				? `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
				: "unknown-date";

			const label = date
				? new Intl.DateTimeFormat(undefined, { day: "numeric", month: "long", year: "numeric" }).format(date)
				: "Date unavailable";

			const group = groups.at(-1);

			if (group?.key === key) {
				group.media.push(item);
			} else {
				groups.push({ key, label, media: [item], startIndex: index });
			}
		}

		return groups;
	}

	var fragment_3 = $.comment();
	var node_13 = $.first_child(fragment_3);

	{
		var consequent_8 = ($$anchor) => {
			var div_1 = root_10();

			$.append($$anchor, div_1);
		};

		var consequent_9 = ($$anchor) => {
			var div_2 = root_12();

			$.each(div_2, 21, () => $.get(dateGroups), (group) => group.key, ($$anchor, group) => {
				var section = root_11();
				var h2 = $.child(section);
				var text_2 = $.child(h2, true);

				$.reset(h2);

				var div_3 = $.sibling(h2, 2);
				var node_14 = $.child(div_3);

				mediaTiles(node_14, () => $.get(group).media, () => $.get(group).startIndex);
				$.reset(div_3);
				$.reset(section);

				$.template_effect(() => {
					$.set_attribute(section, 'aria-labelledby', `gallery-date-${$.get(group).key}`);
					$.set_attribute(h2, 'id', `gallery-date-${$.get(group).key}`);
					$.set_text(text_2, $.get(group).label);
				});

				$.append($$anchor, section);
			});

			$.reset(div_2);
			$.append($$anchor, div_2);
		};

		var alternate_2 = ($$anchor) => {
			var div_4 = root_13();
			var node_15 = $.child(div_4);

			mediaTiles(node_15, () => $$props.media, () => 0);
			$.reset(div_4);
			$.append($$anchor, div_4);
		};

		$.if(node_13, ($$render) => {
			if ($$props.media.length === 0) $$render(consequent_8); else if (groupByDate()) $$render(consequent_9, 1); else $$render(alternate_2, -1);
		});
	}

	$.append($$anchor, fragment_3);
	$.pop();
}